import { ReactNode } from 'react';
import styled from 'styled-components';

import { borderWidth, color, cornerRadius, font, space } from '@creditornot/alchemy-react/tokens';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const BoxHeading = styled.div`
  align-items: center;
  border-bottom-width: ${borderWidth.regularMedium};
  border-bottom-style: solid;
  border-bottom-color: ${color.borderSubdued};
  display: flex;
  font: ${font.bodyLabel};
  gap: ${space.regularLarge};
  margin: ${space.regularXxlarge};
  margin-bottom: 0;
  padding-bottom: ${space.regularXlarge};

  &::before {
    align-items: center;
    background-color: ${color.bgSurface};
    border-radius: ${cornerRadius.large};
    border-width: ${borderWidth.regularMedium};
    border-style: solid;
    border-color: ${color.border};
    content: counter(step, upper-alpha);
    counter-increment: step;
    display: flex;
    font: ${font.footnoteLabel};
    height: 32px;
    justify-content: center;
    width: 32px;
  }
`;

const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${space.regularXxxlarge};
  overflow: auto;
  padding: ${space.regularXxlarge};
  padding-top: ${space.regularXxxlarge};
`;

type Props = {
  children: ReactNode;
  title: ReactNode;
};

export function Step({ children, title }: Props) {
  return (
    <Box>
      <BoxHeading>{title}</BoxHeading>
      <Content>{children}</Content>
    </Box>
  );
}
